import { render } from "./ConfigPane.vue?vue&type=template&id=75ab4097&ts=true"
import script from "./ConfigPane.vue?vue&type=script&lang=ts"
export * from "./ConfigPane.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Workspace\\weedheads\\10-gemfarm\\custom-ui\\gem-farm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__